import type { ReactNode } from "react";
import type { BlockerFunction } from "react-router-dom";
import { useBlocker } from "react-router-dom";

type ReactRouterPromptChildren = (data: { isActive: boolean; onConfirm: () => void; onCancel: () => void }) => ReactNode;

type ReactRouterPromptProps = {
  when: boolean | BlockerFunction;
  children: ReactRouterPromptChildren;
};

const noop = () => undefined;

const ReactRouterPrompt = ({ when, children }: ReactRouterPromptProps) => {
  const blocker = useBlocker(when);
  const isActive = blocker.state === "blocked";

  return <>{children({ isActive, onConfirm: blocker.proceed ?? noop, onCancel: blocker.reset ?? noop })}</>;
};

export default ReactRouterPrompt;
